<template>
  <div class="chat-selected-contact ml-4">
    <div class="chat-selected-contact__avatar">
      <profile-preview-image
        :profileId="contact.profileId"
        :uuid="contact.uuid"
        :avatarSize="48"
        :avatarClasses="['avatar', 'rounded']"
      />
    </div>
    <span class="chat-selected-contact__name">
      {{
        contact.isFreeUser || !contactProfilesPreviews
          ? 'Free User'
          : contactProfilesPreviews.firstName || contact.firstName
      }}
    </span>
    <v-btn
      v-if="actionIcon && !contact.isFreeUser"
      class="chat-selected-contact__button"
      color="primary"
      icon
      x-small
      :size="16"
      @click="$emit('contact:action', contact.profileId)"
    >
      <v-icon size="16"> {{ actionIcon }}</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ProfilePreviewImage from '@/components/profile/ProfilePreviewImage.vue'
export default {
  name: 'NewChatSelectedContact',
  components: {
    ProfilePreviewImage
  },
  props: {
    contact: {
      type: Object,
      default: () => ({}),
    },
    actionIcon: {
      type: String,
      default: '',
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapState('profilePreviewsStates', ['profilePreviews']),
    contactProfilesPreviews() {
      const profilePreview = this.profilePreviews.find(el => el.uuid === this.contact.uuid) || {}
      return {
        ...this.contact,
        ...profilePreview
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/mixins.scss';
$button-size: 16px;
$avatar-height: 48px;

.chat-selected-contact {
  position: relative;
  display: flex;
  flex-direction: column;

  &__name {
    color: $bh-blue;
    font-size: 0.8rem;
    line-height: 0.8rem;
    text-align: center;
    max-width: 48px;
    padding: 0.25 * $gutter 0;
  }

  &__button {
    position: absolute;
    right: -0.5 * $button-size;
    top: 0.5 * $avatar-height - 0.5 * $button-size;
  }

  @include imageAvatar(
    $class-name: 'chat-selected-contact',
    $height: $avatar-height,
    $width: 48px
  );
}
</style>
